(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-page-workstation"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {

    gsap.registerPlugin(ScrollTrigger);

    // Tween/animation for "extraordinary" text.
    translateWhiteBgImageOnYaxisTween = gsap.to('.workstation-section .extraordinary-text', {
      duration: 0.1,
      backgroundPosition: '0% 66%, 0% 0%',
      ease: 'pwoer1.out',
    });
    
    translateSvgBgImageOnXaxisTween = gsap.to('.workstation-section .extraordinary-text', {
      duration: 0.4,
      backgroundPosition: '0% 0%, 100% 100%',
      ease: 'pwoer1.out',
      delay:0.5,
    });

    extraordinaryTextTimeline = gsap.timeline();
    extraordinaryTextTimeline.add(translateWhiteBgImageOnYaxisTween);
    extraordinaryTextTimeline.add(translateSvgBgImageOnXaxisTween);

    // Trigger for above animation.
    ScrollTrigger.create({
      // trigger: '.workstation-section .workstation-title',
      // start: 'top 25%',
      trigger: ".workstation-section .workstation-video",
      start: "top bottom",
      // end: '+=200px', // all card's animation ends at the last card's start + stickDistance. Why?
      // end: "bottom center",
      // pin: true,
      // markers: true,
      pinSpacing: false,
      // ease: "none",
      animation: extraordinaryTextTimeline,
      toggleActions: 'play none none none',
      // scrub: true,
      // markers: true,
      id: 'workstation-video-title',
      once: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-desk-aesthetic-images-carousel-section"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    new Glide('.aesthetic-images-carousel-section .glide',{
        type: 'carousel'
    }).mount();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-lifestyle-images-section"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // console.log(window.innerWidth);
    // console.log(Math.min(parseInt(window.innerWidth), 2000));
    // console.log(Math.min(parseInt(window.innerWidth), 2000) / (536+30));
    const gapBetweenSlides = 30; // 30px.
    const widthOfEachSlide = 536; //536px for each image.
    const perViewSlides = Math.min(parseInt(window.innerWidth), 2000) / (536 + 30); // Can show these many images without distorting the images in slides.

    new Glide('.lifestyle-images-section.glide', {
      type: 'slider',
      perView: perViewSlides,
      breakpoints: {
        1080: {
          perView: 1,
          gap: 30,
          // focusAt: 'center'
          bound: true,
        },
      },
      bound: true,
      startAt: 0,
      gap: 30,
      rewind: false,
      focusAt: 0,
      // slideWidth: '536px',
    }).mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-banner-section"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var elem = document.querySelector('.sale-banner-container');

    if (!elem) {
      return;
    }

    const endDate = document.querySelector('#sale-end-date')?.dataset['saleEndDate'];
    // Set the target date and time for the countdown (YYYY-MM-DD format)
    const targetDate = new Date(endDate).getTime();

    const countdownFunction = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance < 0) {
        try {
          clearInterval(countdownFunction);
          if (distance < 0) {
            elem.remove();
          }
        } catch (error) {
          console.error(error);
        }
        return;
      }

      // const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      // const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const hours = Math.floor(distance / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // document.getElementById('days').innerText = days;
      document.getElementById('hours').innerText = hours;
      if (minutes < 10) {
        // Pad left with one 0.
        minutes = `0${minutes}`;
      }
      document.getElementById('minutes').innerText = minutes;
      if (seconds < 10) {
        // Pad left with one 0.
        seconds = `0${seconds}`;
      }
      document.getElementById('seconds').innerText = seconds;
    }, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["splash-screen"]) return;
  try {
    
  const trivias = document.querySelectorAll('.trivia-text');
  var activeIndex = 0;
  if (trivias.length) {
    trivias[activeIndex].classList.add('active');
  }

  const timerHandle = setInterval(showNextTrivia, 3000);

  function showNextTrivia() {
    trivias[activeIndex].classList.remove('active');
    activeIndex = (activeIndex + 1) % trivias.length;
    trivias[activeIndex].classList.add('active');
  }

  } catch(e) { console.error(e); }
})();
})();
